import { Flex } from "antd";
import { useTranslation } from "react-i18next";

import { ConfirmationModalProps } from "./types";
import BaseButton from "../Button/BaseButton";
import BaseModal from "./BaseModal";

import "./styles.css";

const ConfirmationModal = ({
  open,
  onCancel,
  onConfirm,
  title,
  confirmButtonText,
  content,
  isLoading = false,
}: ConfirmationModalProps) => {
  const { t } = useTranslation();

  return (
    <BaseModal
      classNames={{
        wrapper: "confirmation-modal",
      }}
      width={500}
      open={open}
      onCancel={onCancel}
      closable={!isLoading}
      maskClosable={!isLoading}
      keyboard={!isLoading}
      title={title}
      footer={
        <Flex wrap justify="end" align="center" gap={"small"}>
          <BaseButton
            variant="tertiary"
            onClick={onCancel}
            disabled={isLoading}
          >
            {t("buttons.cancel")}
          </BaseButton>

          <BaseButton onClick={onConfirm} loading={isLoading}>
            {confirmButtonText}
          </BaseButton>
        </Flex>
      }
    >
      {content}
    </BaseModal>
  );
};

export default ConfirmationModal;
